/**
 * Checkout draft persistence (sessionStorage).
 *
 * Used by the guest sign-in interception flow: when a guest taps "Place
 * Order" on the checkout page, we save the current form/selection state to
 * sessionStorage before navigating to `/checkout/sign-in` (which unmounts
 * the Checkout component). On the user's return, Checkout reads the draft
 * and rehydrates its useState defaults so nothing is lost.
 *
 * Cleared after a successful order placement. sessionStorage scoping means
 * a stale draft from a prior browser session is impossible — the storage
 * empties when the tab/window closes.
 */

const KEY = 'checkout-draft-v1';

export function saveCheckoutDraft(draft) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(draft));
  } catch {
    // ignore — sessionStorage may be disabled (private mode quota, etc.)
  }
}

export function loadCheckoutDraft() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearCheckoutDraft() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
